"use client";

import type { ReactNode } from "react";
import { AuthProvider } from "./AuthContext";
import { FlowProvider } from "./FlowContext";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <FlowProvider>{children}</FlowProvider>
    </AuthProvider>
  );
}
